import React, { Component} from "react";
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Fade from '@material-ui/core/Fade';
import Play from "mdi-material-ui/PlayCircleOutline"

const styles = theme => ({
  root: {
    position: "relative",
    marginBottom: theme.spacing.unit * 3,

    height: "100%",
    width: "100%",

  },
  imgContainer:{
    position: "absolute",
    top: 0,
    backgroundColor: "white",
    height: "100%",
    width: "100%",

  },
  iframe:{
    position: "absolute",
    top: 0,
    zIndex: 2000,
  },
  playButtonContainer:{

    position: "absolute",
    top: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems:"center"
  },
  playButton:{
    color: theme.palette.background.dark,
    height: 80,
    width: 80,

  }
});

class YouTubeFrame extends Component{

  state = {
    autoplay: "1",
    showVideo: false,
  }

  toggleVideo = ()=>{
    this.setState({showVideo: !this.state.showVideo})
  }

  render(){
    let videoSrc = "https://www.youtube.com/embed/" +
       this.props.video + "?autoplay=" +
       this.state.autoplay + "&rel=" +
       this.props.rel + "&modestbranding=" +
       this.props.modest+
       "&theme=dark" + "&showinfo=0" + "&frameborder=0" + "&autohide=0"


    return (
        <div className={this.props.classes.root}>

          {
            this.state.showVideo && (
              <iframe
                title="yt"
                className={this.props.classes.iframe}
                type="text/html"
                width="100%"
                height="100%"
                src={videoSrc}
                frameBorder="0"

                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              />
            )
          }
          <Fade in={!this.state.showVideo}  timeout={1000}>
            <div className={this.props.classes.imgContainer}>
              <span className={this.props.classes.playButtonContainer}>
                  <IconButton onClick={this.toggleVideo} className={this.props.classes.playButton}><Play style={{fontSize: 70}}/></IconButton>
              </span>

              <img src={this.props.imgUrl} alt="background" width="100%" height="100%" />
            </div>
          </Fade>

        </div>
    )
  }

};

export default withStyles(styles, { withTheme: true })(YouTubeFrame);



// WEBPACK FOOTER //
// ./src/components/reusableComponents/YouTubeFrame.js